var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.359 13.7227C10.3757 13.7441 10.397 13.7613 10.4214 13.7732C10.4457 13.7851 10.4725 13.7912 10.4996 13.7912C10.5267 13.7912 10.5534 13.7851 10.5778 13.7732C10.6022 13.7613 10.6235 13.7441 10.6402 13.7227L13.1402 10.5598C13.2317 10.4437 13.1491 10.2718 12.9996 10.2718H11.3456V2.71824C11.3456 2.62003 11.2652 2.53967 11.167 2.53967H9.82771C9.72949 2.53967 9.64914 2.62003 9.64914 2.71824V10.2696H7.99958C7.85003 10.2696 7.76744 10.4415 7.85896 10.5575L10.359 13.7227ZM18.6692 12.9415H17.3299C17.2317 12.9415 17.1514 13.0218 17.1514 13.12V16.5575H3.8478V13.12C3.8478 13.0218 3.76744 12.9415 3.66922 12.9415H2.32994C2.23172 12.9415 2.15137 13.0218 2.15137 13.12V17.5397C2.15137 17.9348 2.47056 18.254 2.86565 18.254H18.1335C18.5286 18.254 18.8478 17.9348 18.8478 17.5397V13.12C18.8478 13.0218 18.7674 12.9415 18.6692 12.9415Z",
    fill: "#FAAD14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.47eae50ba2d5ce4c5efa6d322d7b04c7.svg";
export { ForwardRef as ReactComponent };